import dayjs from 'dayjs';
import { ChangeEvent, useState } from 'react';
import { IOptions } from 'utils/types';

import EditIcon from '@mui/icons-material/Edit';
import {
  Button,
  Grid2 as Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';

import CardMainContainer from 'components/CardMainContainer';
import CustomAutocompleteMultiple from 'components/CustomAutocompleteMultiple/CustomAutocompleteMultiple';
import CustomSelectMultiple from 'components/CustomSelectMultiple';
import MonthPicker from 'components/MonthPicker';

import {
  ButtonFilterContainer,
  ClearFilterButton,
  WrapperContainerBlur,
} from './DataTableBlur.styles';

const data = [
  {
    obrigacao: 'EFD ICMS/IPI 08/2023',
    tipo: 'Original',
    etapa: 'Validação PVA',
    dataProcessamento: '04/09/2023 - 10:44',
    cpfCnpj: '12.123.123/1234-12',
    nomeEmpresarial: 'Empresa Modelo LTDA',
  },
  {
    obrigacao: 'EFD ICMS/IPI 08/2023',
    tipo: 'Retificação 1',
    etapa: 'Validação PVA',
    dataProcessamento: '04/09/2023 - 10:50',
    cpfCnpj: '23.234.234/2345-23',
    nomeEmpresarial: 'Empresa Modelo II LTDA',
  },
];

const DataTableBlur = () => {
  const [columns, setColumns] = useState<IOptions[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <WrapperContainerBlur data-testid="data-table-blur">
      <CardMainContainer title="Busca de Arquivos">
        <Grid container spacing={5} mb={8}>
          <Grid size={4}>
            <CustomAutocompleteMultiple
              name="empresas"
              label="Empresas"
              id={'autocomplete_with_select_all'}
              multiple
              fullWidth
              options={[]}
              setValue={setColumns}
              disableCloseOnSelect
              freeSolo={false}
              value={columns}
            />
          </Grid>

          <Grid size={3}>
            <MonthPicker
              startDate={dayjs()}
              label="Competência"
              name="competencia"
              setValue={function (): void {
                throw new Error('Function not implemented.');
              }}
              value={dayjs()}
            />
          </Grid>

          <Grid size={2}>
            <CustomSelectMultiple
              id="etapa-paralisacao"
              name="etapa-paralisacao"
              label="Etapa de Paralisação"
              options={[]}
              setValue={function (): void {
                throw new Error('Function not implemented.');
              }}
              value={[]}
            />
          </Grid>

          <ButtonFilterContainer size={3}>
            <Button variant="contained" color="primary" size="small">
              Filtrar
            </Button>
            <ClearFilterButton
              color="secondary"
              size="medium"
              disableRipple
              disableTouchRipple
              disableFocusRipple
            >
              Limpar filtros
            </ClearFilterButton>
          </ButtonFilterContainer>
        </Grid>

        <>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Obrigação</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Etapa</TableCell>
                  <TableCell>Data de Processamento</TableCell>
                  <TableCell>CPF/CNPJ</TableCell>
                  <TableCell>Nome Empresarial</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor:
                          index % 2 === 0
                            ? 'var(--mui-palette-background-paper)'
                            : 'var(--mui-palette-background-default)',
                      }}
                    >
                      <TableCell>{row.obrigacao}</TableCell>
                      <TableCell>{row.tipo}</TableCell>
                      <TableCell>{row.etapa}</TableCell>
                      <TableCell>{row.dataProcessamento}</TableCell>
                      <TableCell>{row.cpfCnpj}</TableCell>
                      <TableCell>{row.nomeEmpresarial}</TableCell>
                      <TableCell>
                        <IconButton>
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count !== -1 ? count : `mais de ${to}`}`
            }
          />
        </>
      </CardMainContainer>
    </WrapperContainerBlur>
  );
};

export default DataTableBlur;
